(function () {
  var DAY1 = {
    FL: 1, GA: 1, AL: 1, SC: 1, NC: 1, TN: 1, MS: 1, LA: 1, AR: 1, TX: 1,
    OK: 1, MO: 1, IL: 1, IN: 1, OH: 1, KY: 1, WV: 1, VA: 1, PA: 1, MI: 1,
    WI: 1, IA: 1, KS: 1, WA: 1, OR: 1, ID: 1, NV: 1, CA: 1, UT: 1, AZ: 1
  };
  var DAY2 = {
    NY: 1, CT: 1, RI: 1, MA: 1, VT: 1, NH: 1, ME: 1, NJ: 1, DE: 1, MD: 1,
    ND: 1, SD: 1, NE: 1, CO: 1, NM: 1, MT: 1, WY: 1
  };
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var GEO_KEY = 'ttPdpGeo';
  var ZIP_KEY = 'ttPdpZip';

  function digitsZip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 5);
  }

  function stateFromZip(zip) {
    var n = parseInt(digitsZip(zip), 10);
    if (!n) return '';
    if (n >= 35000 && n <= 36999) return 'AL';
    if (n >= 99500 && n <= 99999) return 'AK';
    if (n >= 85000 && n <= 86599) return 'AZ';
    if (n >= 71600 && n <= 72999) return 'AR';
    if (n >= 90000 && n <= 96199) return 'CA';
    if (n >= 80000 && n <= 81699) return 'CO';
    if (n >= 6000 && n <= 6999) return 'CT';
    if (n >= 19700 && n <= 19999) return 'DE';
    if (n >= 20000 && n <= 20599) return 'DC';
    if (n >= 32000 && n <= 34999) return 'FL';
    if ((n >= 30000 && n <= 31999) || (n >= 39800 && n <= 39999)) return 'GA';
    if (n >= 96700 && n <= 96899) return 'HI';
    if (n >= 83200 && n <= 83899) return 'ID';
    if (n >= 60000 && n <= 62999) return 'IL';
    if (n >= 46000 && n <= 47999) return 'IN';
    if (n >= 50000 && n <= 52899) return 'IA';
    if (n >= 66000 && n <= 67999) return 'KS';
    if (n >= 40000 && n <= 42799) return 'KY';
    if (n >= 70000 && n <= 71499) return 'LA';
    if (n >= 3900 && n <= 4999) return 'ME';
    if (n >= 20600 && n <= 21999) return 'MD';
    if ((n >= 1000 && n <= 2799) || (n >= 5500 && n <= 5599)) return 'MA';
    if (n >= 48000 && n <= 49999) return 'MI';
    if (n >= 55000 && n <= 56799) return 'MN';
    if (n >= 38600 && n <= 39799) return 'MS';
    if (n >= 63000 && n <= 65899) return 'MO';
    if (n >= 59000 && n <= 59999) return 'MT';
    if (n >= 68000 && n <= 69399) return 'NE';
    if (n >= 88900 && n <= 89899) return 'NV';
    if (n >= 3000 && n <= 3899) return 'NH';
    if (n >= 7000 && n <= 8999) return 'NJ';
    if (n >= 87000 && n <= 88499) return 'NM';
    if ((n >= 500 && n <= 599) || (n >= 10000 && n <= 14999)) return 'NY';
    if (n >= 27000 && n <= 28999) return 'NC';
    if (n >= 58000 && n <= 58899) return 'ND';
    if (n >= 43000 && n <= 45999) return 'OH';
    if (n >= 73000 && n <= 74999) return 'OK';
    if (n >= 97000 && n <= 97999) return 'OR';
    if (n >= 15000 && n <= 19699) return 'PA';
    if (n >= 2800 && n <= 2999) return 'RI';
    if (n >= 29000 && n <= 29999) return 'SC';
    if (n >= 57000 && n <= 57799) return 'SD';
    if (n >= 37000 && n <= 38599) return 'TN';
    if ((n >= 75000 && n <= 79999) || (n >= 88500 && n <= 88599)) return 'TX';
    if (n >= 84000 && n <= 84799) return 'UT';
    if (n >= 5000 && n <= 5999) return 'VT';
    if ((n >= 20100 && n <= 20199) || (n >= 22000 && n <= 24699)) return 'VA';
    if (n >= 98000 && n <= 99499) return 'WA';
    if (n >= 24700 && n <= 26899) return 'WV';
    if (n >= 53000 && n <= 54999) return 'WI';
    if (n >= 82000 && n <= 83199) return 'WY';
    return '';
  }

  function isNoShip(st) {
    return st === 'AK' || st === 'HI';
  }

  function transitDays(st) {
    if (isNoShip(st)) return 0;
    if (!st) return 3;
    if (DAY1[st]) return 1;
    if (DAY2[st]) return 2;
    return 3;
  }

  function nyParts(date) {
    var map = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'long',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return {
      weekday: map.weekday,
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10),
      minute: parseInt(map.minute, 10) || 0,
      second: parseInt(map.second, 10) || 0
    };
  }

  function fromNyYmd(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day, 17, 0, 0));
  }

  function addCalendarDays(parts, count) {
    var utc = fromNyYmd(parts.year, parts.month, parts.day);
    utc.setUTCDate(utc.getUTCDate() + count);
    return nyParts(utc);
  }

  function nextWeekday(parts) {
    var cursor = parts;
    do {
      cursor = addCalendarDays(cursor, 1);
    } while (cursor.weekday === 'Saturday' || cursor.weekday === 'Sunday');
    return cursor;
  }

  function shipDay(now) {
    var parts = nyParts(now);
    var weekend = parts.weekday === 'Saturday' || parts.weekday === 'Sunday';
    if (weekend || parts.hour >= 14) return nextWeekday(parts);
    return parts;
  }

  function addBusinessDays(parts, days) {
    var cursor = parts;
    var added = 0;
    while (added < days) {
      cursor = addCalendarDays(cursor, 1);
      if (cursor.weekday !== 'Saturday' && cursor.weekday !== 'Sunday') added += 1;
    }
    return cursor;
  }

  function ordinal(n) {
    var v = n % 100;
    if (v >= 11 && v <= 13) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }

  function formatArrive(parts) {
    return parts.weekday + ', ' + MONTHS[parts.month - 1] + ' ' + ordinal(parts.day);
  }

  function nyUtcMs(year, month, day, hour, minute) {
    var utc = Date.UTC(year, month - 1, day, hour + 4, minute || 0, 0);
    var i;
    for (i = 0; i < 6; i += 1) {
      var p = nyParts(new Date(utc));
      var delta =
        Date.UTC(year, month - 1, day, hour, minute || 0, 0) -
        Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, 0);
      if (!delta) break;
      utc += delta;
    }
    return utc;
  }

  function cutoffMs(now) {
    var day = shipDay(now);
    return nyUtcMs(day.year, day.month, day.day, 14, 0);
  }

  function formatCountdown(ms) {
    var remain = Math.max(0, ms);
    var totalMin = Math.floor(remain / 60000);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    return h + 'h ' + m + 'm';
  }

  function arrivalCopy(st) {
    var days = transitDays(st);
    if (!days) return '';
    return formatArrive(addBusinessDays(shipDay(new Date()), days));
  }

  function placeCopy(city, st, zip) {
    var z = digitsZip(zip);
    var bits = [];
    if (city) bits.push(city);
    if (st && z) bits.push(st + ' ' + z);
    else if (st) bits.push(st);
    else if (z) bits.push(z);
    return bits.join(', ');
  }

  function readJson(key) {
    try {
      var raw = sessionStorage.getItem(key) || localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeSession(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function writeLocal(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function paintEta(root) {
    var st = root.getAttribute('data-tt-st') || '';
    var countEl = root.querySelector('[data-tt-eta-countdown]');
    var dateEl = root.querySelector('[data-tt-eta-date]');
    if (isNoShip(st)) {
      if (countEl) countEl.textContent = '';
      if (dateEl) dateEl.textContent = '';
      return;
    }
    var now = new Date();
    if (countEl) countEl.textContent = formatCountdown(cutoffMs(now) - now.getTime());
    if (dateEl) dateEl.textContent = arrivalCopy(st);
  }

  var etaRoots = [];
  var etaTimer = null;

  function ensureEtaTimer() {
    if (etaTimer) return;
    etaTimer = setInterval(function () {
      var i;
      for (i = 0; i < etaRoots.length; i += 1) paintEta(etaRoots[i]);
    }, 1000);
  }

  function applyDestination(root, dest) {
    var placeEl = root.querySelector('[data-tt-dest-place]');
    var leadEl = root.querySelector('[data-tt-dest-lead]');
    var zipEl = root.querySelector('[data-tt-dest-zip]');
    var city = dest && dest.city ? dest.city : '';
    var st = dest && dest.st ? dest.st : '';
    var zip = dest && dest.zip ? digitsZip(dest.zip) : '';
    var noship = isNoShip(st);
    root.setAttribute('data-tt-zone', noship ? 'noship' : 'lower48');
    root.setAttribute('data-tt-st', st);
    if (leadEl) leadEl.textContent = noship ? '' : 'Delivers Free to';
    if (placeEl) placeEl.textContent = placeCopy(city, st, zip);
    if (zipEl && zip && zipEl.value.replace(/\D/g, '') !== zip) zipEl.value = zip;
    paintEta(root);
  }

  function fetchJson(url, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || 2500);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('http');
        return res.json();
      })
      .finally(function () { clearTimeout(timer); });
  }

  function geoFromIpapi(json) {
    if (!json || (json.country !== 'US' && json.country_code !== 'US')) return null;
    var st = String(json.region_code || json.region || '').toUpperCase();
    if (st.length !== 2) st = stateFromZip(json.postal);
    var city = json.city ? String(json.city) : '';
    var zip = digitsZip(json.postal);
    if (!st && !city && !zip) return null;
    return { city: city, st: st, zip: zip };
  }

  function geoFromZippo(json, zip) {
    var place = json && json.places && json.places[0];
    if (!place) {
      var stOnly = stateFromZip(zip);
      return stOnly ? { city: '', st: stOnly, zip: digitsZip(zip) } : null;
    }
    return {
      city: place['place name'] || '',
      st: String(place['state abbreviation'] || stateFromZip(zip) || '').toUpperCase(),
      zip: digitsZip(zip)
    };
  }

  function bindStockMap(root) {
    var mapEl = root.parentNode ? root.parentNode.querySelector('[data-tt-stock-map]') : root.querySelector('[data-tt-stock-map]');
    if (!mapEl) {
      var host = root.closest ? root.closest('.product-info-inventory') : null;
      if (host) mapEl = host.querySelector('[data-tt-stock-map]');
    }
    if (!mapEl) return;
    var map = {};
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    function apply(id) {
      if (id == null || id === '') return;
      var key = String(id);
      if (!Object.prototype.hasOwnProperty.call(map, key)) return;
      var row = map[key];
      var available = typeof row === 'object' && row !== null ? !!row.available : !!row;
      var qty = typeof row === 'object' && row !== null ? parseInt(row.qty, 10) : 0;
      if (!qty || qty < 1) qty = 0;
      root.setAttribute('data-available', available ? 'true' : 'false');
      var qtyEl = root.querySelector('[data-tt-stock-qty]');
      var labelEl = root.querySelector('[data-tt-stock-label]');
      if (labelEl) {
        if (available && qty > 0) {
          labelEl.innerHTML = 'In Stock: <span data-tt-stock-qty>' + qty + '</span> Available';
        } else if (available) {
          labelEl.textContent = 'In Stock';
        }
      } else if (qtyEl) {
        qtyEl.textContent = available && qty > 0 ? String(qty) : '';
      }
    }
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || t.name !== 'id') return;
      apply(t.value);
    });
    if (window.webvista && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.webvista.subscribe(window.PUB_SUB_EVENTS.variantChange, function (payload) {
        var variant = payload && (payload.variant || payload.currentVariant);
        if (variant && variant.id) apply(variant.id);
      });
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-tt-bound') === '1') return;
    root.setAttribute('data-tt-bound', '1');
    bindStockMap(root);
    etaRoots.push(root);
    ensureEtaTimer();
    applyDestination(root, { city: '', st: '', zip: '' });

    var zipEl = root.querySelector('[data-tt-dest-zip]');
    function useDest(dest, persist) {
      if (!dest) return;
      applyDestination(root, dest);
      writeSession(GEO_KEY, dest);
      if (persist) writeLocal(ZIP_KEY, dest);
    }

    function lookupZip(zip) {
      var z = digitsZip(zip);
      if (z.length !== 5) return;
      var fallback = { city: '', st: stateFromZip(z), zip: z };
      if (fallback.st) useDest(fallback, true);
      fetchJson('https://api.zippopotam.us/us/' + z, 2500)
        .then(function (json) {
          var dest = geoFromZippo(json, z);
          if (dest) useDest(dest, true);
        })
        .catch(function () {});
    }

    if (zipEl) {
      zipEl.addEventListener('change', function () { lookupZip(zipEl.value); });
      zipEl.addEventListener('input', function () {
        if (digitsZip(zipEl.value).length === 5) lookupZip(zipEl.value);
      });
    }

    var savedZip = readJson(ZIP_KEY);
    if (savedZip && digitsZip(savedZip.zip).length === 5) {
      useDest({
        city: savedZip.city || '',
        st: savedZip.st || stateFromZip(savedZip.zip),
        zip: digitsZip(savedZip.zip)
      }, false);
      if (zipEl) zipEl.value = digitsZip(savedZip.zip);
      return;
    }

    var cached = readJson(GEO_KEY);
    if (cached && (cached.st || cached.zip)) {
      useDest(cached, false);
      return;
    }

    fetchJson('https://ipapi.co/json/', 2500)
      .then(function (json) {
        var dest = geoFromIpapi(json);
        if (dest) useDest(dest, false);
      })
      .catch(function () {});
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-tt-pdp-stock-ship]');
    for (var i = 0; i < nodes.length; i += 1) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
